/**
 * NowOnAuctionCard.js
 *
 * Shows players which item the host currently has up for auction (or that it's been sold).
 */

import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import { getAuctionSettings } from "../assets/Rules";
import { getRoomLibrary } from "../library/libraries";

const NowOnAuctionCard = ({ room }) => {
    if (room.currentMovieIndex === undefined) return null;

    const library = getRoomLibrary(room);
    const item = library.items[room.currentMovieIndex];
    if (!item) return null;

    const sale = room.lastSale && (room.lastSale.itemIndex ?? -1) === room.currentMovieIndex ? room.lastSale : null;
    const details = library.attributes
        .filter((attribute) => attribute.kind !== "name" && attribute.kind !== "score")
        .map((attribute) => item.values?.[attribute.name])
        .filter((value) => value !== undefined && value !== "");

    return (
        <div className="rounded-2xl border border-zinc-700 bg-zinc-950 p-5 overflow-hidden">
            <div className="flex items-center justify-between text-xs uppercase tracking-widest">
                <span className="text-zinc-500">
                    {room.round === 2 && <span className="text-peach font-semibold">Comeback round · </span>}
                    #{room.currentMovieIndex + 1} of {library.items.length}
                </span>
                {sale ? (
                    <span className="text-yellow font-semibold">Sold</span>
                ) : (
                    <span className="inline-flex items-center gap-2 text-red font-semibold">
                        <span className="w-2 h-2 rounded-full bg-red animate-pulse" /> Up for auction
                    </span>
                )}
            </div>

            <AnimatePresence mode="wait">
                <motion.div
                    key={room.currentMovieIndex}
                    initial={{ opacity: 0, y: 12 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -12 }}
                    transition={{ duration: 0.25 }}
                    className="mt-3 text-left"
                >
                    <div className="text-2xl sm:text-3xl font-bold text-white">{item.name}</div>
                    <div className="mt-1 text-zinc-400">
                        {details.map((value) => `${value} · `).join("")}
                        {library.scoreAttribute} <span className="text-white font-semibold">{item.score}</span>
                    </div>
                    {sale && getAuctionSettings(room).showSales && (
                        <div className="mt-3 text-zinc-300">
                            Went to <span className="text-white font-semibold">{sale.teamName}</span> for{" "}
                            <span className="text-yellow font-semibold">₹{sale.amount}</span>
                        </div>
                    )}
                </motion.div>
            </AnimatePresence>
        </div>
    );
};

export default NowOnAuctionCard;
